// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Libraries
import { Provider } from 'react-redux'

// Components
import EmbeddableCartLines from 'store/modules/cart/EmbeddableCart/Lines'
import EmbeddableCartMobileLines from 'store/modules/cart/EmbeddableCart/Mobile/Lines'
import Themed from 'store/v2/react/components/Themed'

// Shared

const store = window.booqableStore

export default class EmbeddableCartLinesContainer extends Component {
  static displayName = 'EmbeddableCartLinesContainer'

  static propTypes = {
    compact: PropTypes.bool
  }

  render () {
    const { compact } = this.props

    return (
      <Provider store={store}>
        <Themed>
          <div className="booqable-component" style={{ display: 'none' }}>
            {compact ?
              <EmbeddableCartMobileLines /> :
              <EmbeddableCartLines />}
          </div>
        </Themed>
      </Provider>
    )
  }
}
